import React, { useState, useEffect, useRef } from "react";
import moment from "moment";

import { DayPicker } from "react-day-picker";
import { useNavigation } from "react-day-picker";
import submit from "submit-form";
import { usePrevious } from "../hooks/usePrevious";

const {
  DATE_FORMATS: { DATE_DAY_FORMAT },
} = require("../constants");

function DatePicker({ locals }) {
  const { activeUser } = locals;
  const startingCalendarDay = activeUser.startingCalendarDay || 0;
  const [expandedCalendar, setExpandedCalendar] = useState(false);
  const [activeDay, setActiveDay] = useState(
    moment.utc(locals.query.date, DATE_DAY_FORMAT)
  );
  const [mutableDay, setMutableDay] = useState(
    moment.utc(locals.query.date, DATE_DAY_FORMAT)
  );
  const [currentWeek, setCurrentWeek] = useState({ from: null, to: null });
  const [hiddenDays, setHiddenDays] = useState([]);
  const prevState = usePrevious({
    expandedCalendar,
    activeDay,
    mutableDay,
    currentWeek,
  });

  const toggleCalendarExpand = (value) => {
    setExpandedCalendar(value !== undefined ? value : !expandedCalendar);
  };

  useEffect(() => {
    //   This variable is to handle the starting day of the week for momentjs depending on the coach preferences, without changing momentjs general configuration in the whole project
    const amount =
      startingCalendarDay > 0
        ? moment.utc(activeDay).day() < startingCalendarDay
          ? -(7 - startingCalendarDay)
          : startingCalendarDay
        : 0;

    setCurrentWeek({
      from:
        activeDay && moment.utc(activeDay).startOf("week").add(amount, "days"),
      to: activeDay && moment.utc(activeDay).endOf("week").add(amount, "days"),
    });
  }, []);

  useEffect(() => {
    setMutableDay(activeDay);
  }, [activeDay]);

  useEffect(() => {
    prevState && handleMonth(prevState.mutableDay, mutableDay);
    //   This variable is to handle the starting day of the week for momentjs depending on the coach preferences, without changing momentjs general configuration in the whole project
    const amount =
      startingCalendarDay > 0
        ? moment.utc(mutableDay).day() < startingCalendarDay
          ? -(7 - startingCalendarDay)
          : startingCalendarDay
        : 0;
    setCurrentWeek({
      from:
        mutableDay &&
        moment.utc(mutableDay).startOf("week").add(amount, "days"),
      to:
        mutableDay && moment.utc(mutableDay).endOf("week").add(amount, "days"),
    });
  }, [mutableDay]);

  useEffect(() => {
    const newHiddenDays = currentWeek.from &&
      currentWeek.to && [
        {
          // From the first day of the previous month (to avoid problems with starting day of the week)
          from: new Date(
            moment
              .utc(currentWeek.from)
              .subtract(1, "month")
              .startOf("month")
              .toJSON()
              .slice(0, -1)
          ),
          to:
            //     To the previous day of the current week start
            new Date(
              moment
                .utc(currentWeek.from)
                .subtract(1, "days")
                .toJSON()
                .slice(0, -1)
            ),
        },
        {
          // From the next day of the current week end
          from: new Date(
            moment.utc(currentWeek.to).add(1, "days").toJSON().slice(0, -1)
          ),
          //     To the last day of the next month also to avoid problems with starting day of the week
          to: new Date(
            moment
              .utc(currentWeek.to)
              .add(1, "month")
              .endOf("month")
              .toJSON()
              .slice(0, -1)
          ),
        },
      ];

    setHiddenDays(newHiddenDays);
  }, [currentWeek]);

  const setCalendarWeek = (direction) => {
    const newDay =
      direction === "prev"
        ? moment.utc(mutableDay).subtract(1, "week")
        : moment.utc(mutableDay).add(1, "week");
    setMutableDay(newDay);
  };

  const setCalendarNewMonthWeek = (direction) => {
    setMutableDay(
      direction === "prev"
        ? moment.utc(mutableDay).subtract(1, "month")
        : moment.utc(mutableDay).add(1, "month")
    );
  };

  // Force click in the calendar header when navigating throug weeks / months
  const handleMonth = (currentDay, newDay) => {
    moment.utc(newDay).get("month") > moment.utc(currentDay).get("month")
      ? moment.utc(newDay).get("year") === moment.utc(currentDay).get("year")
        ? document.getElementById("btn-go-next-month").click()
        : moment.utc(newDay).get("year") < moment.utc(currentDay).get("year")
        ? document.getElementById("btn-go-prev-month").click()
        : null
      : moment.utc(newDay).get("month") < moment.utc(currentDay).get("month")
      ? moment.utc(newDay).get("year") === moment.utc(currentDay).get("year")
        ? document.getElementById("btn-go-prev-month").click()
        : moment.utc(newDay).get("year") > moment.utc(currentDay).get("year")
        ? document.getElementById("btn-go-next-month").click()
        : null
      : null;
  };

  const handleDaySelect = (date) => {
    toggleCalendarExpand(false);
    setActiveDay(moment.utc(moment(date).format("YYYY-MM-DD"), "YYYY-MM-DD"));
    submit(`/actions/refresh`, {
      method: "GET",
      body: { view: "day", date: moment(date).format("YYYY-MM-DD") },
    });
  };

  // Following ones are the workout days to show them with a dot at the bottom on the calendar
  //   TODO: REVIEW THE FORMAT OF THE DAY (ORIGINALY GETS -1 DAY)
  const workoutDays = locals.currentYearExercises.map(
    //   This slice removes the Z at the end of the date string to take the date at local time
    (excs) => new Date(excs.date.slice(0, -1))
  );

  const workoutDaysStyles = { color: "var(--green)" };

  const currentWeekDaysStyles = {
    color: "var(--white-60)",
    margin: "auto",
  };

  const customCaption = (props) => {
    //     const month =
    //       props &&
    //       props.displayMonth &&
    //       props.displayMonth.toLocaleDateString("en-US", {
    //         timeZone: "UTC",
    //         month: "long",
    //         year: "numeric",
    //       });
    const { goToMonth, nextMonth, previousMonth } = useNavigation();
    return (
      <div className="mobile-datepicker custom-caption-container">
        <img
          className="custom-caption-arrow"
          src="/img/icons/prev-arrow.svg"
          onClick={() => {
            expandedCalendar
              ? setCalendarNewMonthWeek("prev")
              : setCalendarWeek("prev");
          }}
        />
        {/* This hidden button is clicked when the weeks pagination overflows the current month
        so as to go to the PREV month. Executed here due to the need of the useNavigation */}
        <div
          style={{
            visibility: "none",
            height: "0",
            width: "0",
            position: "absolute",
          }}
          id="btn-go-prev-month"
          onClick={() => {
            previousMonth && goToMonth(previousMonth);
          }}
        />
        <span className="custom-caption-header">
          {moment
            .utc(moment(props?.displayMonth).format("YYYY-MM-DD"), "YYYY-MM-DD")
            .format("MMMM YYYY")}
        </span>
        <img
          className="custom-caption-arrow"
          src="/img/icons/next-arrow.svg"
          onClick={() => {
            expandedCalendar
              ? setCalendarNewMonthWeek("next")
              : setCalendarWeek("next");
          }}
        />
        {/* This hidden button is clicked when the weeks pagination overflows the current month
        so as to go to the NEXT month. Executed here due to the need of the useNavigation */}
        <div
          style={{
            visibility: "none",
            height: "0",
            width: "0",
            position: "absolute",
          }}
          id="btn-go-next-month"
          onClick={() => {
            nextMonth && goToMonth(nextMonth);
          }}
        />
      </div>
    );
  };

  return (
    <div className="mobile-datepicker-wrapper only-show-mobile">
      {currentWeek.from && currentWeek.to && (
        <DayPicker
          showOutsideDays
          defaultMonth={new Date(activeDay.toJSON().slice(0, -1))}
          selected={new Date(activeDay.toJSON().slice(0, -1))}
          //   Only will hide the set days if the calendar is not expanded
          hidden={!expandedCalendar && hiddenDays}
          styles={{
            row: { height: 0 },
            cell: { height: 0 },
          }}
          //   This modifier will show the current week
          modifiers={{
            current: {
              from: new Date(currentWeek.from.toJSON().slice(0, -1)),
              to: new Date(currentWeek.to.toJSON().slice(0, -1)),
            },
            workouts: workoutDays,
          }}
          modifiersStyles={{
            current: currentWeekDaysStyles,
            workouts: workoutDaysStyles,
          }}
          components={{ Caption: customCaption }}
          modifiersClassNames={{
            selected: "my-selected",
            workouts: "my-workouts",
          }}
          mode="single"
          //   This callback handles the behavior when clicking a day on the calendar
          onSelect={handleDaySelect}
          required
          weekStartsOn={startingCalendarDay}
        />
      )}
      <div
        style={{ width: "100%", display: "flex", justifyContent: "center" }}
        onClick={() => toggleCalendarExpand()}
      >
        <img
          src="/img/dropdown-icon-white.webp"
          style={{
            width: "25px",
            height: "12px",
            transform: expandedCalendar ? "rotate(180deg)" : "",
            transition: "transform .1s",
          }}
        />
      </div>
    </div>
  );
}

export default DatePicker;
